import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {Grid} from "@mui/material";
import ThumbnailAndNotification from "../../../../../../components/WMS/Mobile/ThumbnailAndNotification";
import {grey300, greyishBlue500} from "../../../../../../assets/jss/main";
import LineItemOptionList from "../../../../../../components/WMS/Mobile/WmsItemList/components/LineItemOptionList";
import Badge from "../../../../../../components/Badge";
import {FormattedMessage} from "react-intl";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import moment from "moment";
import CustomButton from "../../../../../../components/CustomButton";
import {LogsContext} from "../../../logsContext";
import ArrowDownIcon from "../../../../../../components/icons/ArrowDownIcon";
import {WMSContext} from "../../../../context/WMSContext";

WmsItemItem.propTypes = {
    wmsItem: PropTypes.object.isRequired
};

function WmsItemItem({wmsItem}) {
    const {seeItemLog, itemId, selectedItemIdentifier, selectedItemBarcode} = useContext(LogsContext)
    const {currentOrganization} = useContext(WMSContext)
    const orderNumber = currentOrganization?.showDisplayExternalId && wmsItem.order?.displayExternalId
        ? wmsItem.order.displayExternalId
        : wmsItem.order?.externalId

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ArrowDownIcon/>}>
                <Grid container flexWrap={"nowrap"}>
                    <ThumbnailAndNotification link={wmsItem.pictures[0]} alt={wmsItem.name}/>
                    <Grid container direction={"column"}>
                        <Grid container direction={"column"} marginLeft={2}>
                            <Grid
                                item
                                style={{
                                    fontSize: '14px',
                                    color: greyishBlue500,
                                }}
                            >
                                {wmsItem.brand}
                            </Grid>
                            <Grid
                                item
                                style={{
                                    fontSize: '16px',
                                    fontWeight: 600,
                                }}
                            >
                                {orderNumber}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container alignItems={"center"} width={"fit-content"}>
                        <Badge color={"default"} rounded isBold>
                            <FormattedMessage id={`wms.logs.wmsItems.badge.status.${wmsItem.status}`}/>
                        </Badge>
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails sx={{backgroundColor: grey300, padding: 0}}>
                <Grid container sx={{padding: "8px"}} direction={"column"}>

                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.wmsItems.option.label"}/></span>
                        <Grid container direction={'row'} marginLeft={2}>
                            <LineItemOptionList options={wmsItem.options} withOptionName/>
                        </Grid>
                    </Grid>

                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.wmsItems.containerName.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {wmsItem.container?.fullName ? wmsItem.container.fullName : "N/A"}
                        </Badge>

                        {wmsItem.container?.type && (
                            <Badge color={"online"} rounded isBold>
                                <FormattedMessage id={`wms.container.type.name.${wmsItem.container.type}`}/>
                            </Badge>
                        )}

                    </Grid>

                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.wmsItems.barcode.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {wmsItem.barcode}
                        </Badge>
                    </Grid>

                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.wmsItems.updatedAt.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {moment.utc(wmsItem.updatedAt.date).local().format("DD/MM/YYYY HH:mm:ss")}
                        </Badge>
                    </Grid>

                    <Grid item sx={{marginTop: "8px"}}>
                        <CustomButton fullWidth onClick={() => {
                            itemId.current = wmsItem.id
                            selectedItemIdentifier.current = wmsItem.name
                            selectedItemBarcode.current = wmsItem.barcode
                            seeItemLog()
                        }}>
                            <FormattedMessage id={"wms.logs.itemList.seeTheLogs"}/>
                        </CustomButton>
                    </Grid>

                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default WmsItemItem;